export const saveBlob = (blob: Blob, fileName: string) => {
	// create link
	const tempLink = document.createElement("a")
	document.body.appendChild(tempLink)
	// populate blob
	const url = window.URL.createObjectURL(blob)
	tempLink.href = url
	tempLink.download = fileName
	// download
	tempLink.click()
	// remove
	window.URL.revokeObjectURL(url)
	tempLink.parentNode.removeChild(tempLink)
}
